import React, { Component } from 'react';
import { Chart } from 'primereact/chart';

const optionsVerticalBarChart = {
    legend: {
        display: false
    }, scales: {
        xAxes: [{
            ticks: {
                autoSkip: false,
                minRotation: 0,
                maxRotation: 90,
                fontSize: 11,
            }
        }],
        yAxes: [{
            ticks: {
                min: 0,
                fontSize: 11,
            }
        }]
    }
};

class VerticalBarChart extends Component {


    constructor(props) {
        super(props);

        this.state = {
            values: [],
        };
    }

    componentDidMount() {
        this.setState({
            values: JSON.parse(this.props.values),
        });
    }

    render() {

        return (
            <div>
                <Chart type="bar" data={this.state.values} options={optionsVerticalBarChart} />
            </div>
        )
    }
}

export default VerticalBarChart;


// WEBPACK FOOTER //
// ./src/components/VerticalBarChart.js